import { getButtonIcon } from '@helpers/getButtonIcon';
import SvgArrowRight from '@img/icons/arrow-right.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './CtaLink.styles';
const CtaLink = ({ as = 'a', hasArrow = true, icon, children, ...props }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { as: as, "data-has-arrow": !icon && hasArrow, ...props },
            React.createElement("span", null, children),
            icon ? getButtonIcon(icon) : React.createElement(React.Fragment, null, hasArrow && React.createElement(SvgArrowRight, null)))));
};
export default CtaLink;
